/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  SHOW_STATS,
  HIDE_STATS,
  UPDATE_STREAM_STATS,
  UPDATE_RENDERER_STATS,
  RESET_STATS,
  UPDATE_LATENCY
} from '../actions/statistics';
import {RESET} from '../actions/stream';

const initialState = {
  visible: false,
  lag: 0,
  networkState: 2,
  streamStatistics: [],
  height: 0,
  width: 0
};
const statistics = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case SHOW_STATS:
      return {
        ...state,
        visible: true
      };
    case RESET_STATS:
    case HIDE_STATS:
      return {
        ...initialState,
        lag: state.lag
      };
    case UPDATE_RENDERER_STATS:
      return {
        ...state,
        ...action.statistics,
        lag: parseFloat(action.statistics.lag).toFixed(2) || 0
      };
    case UPDATE_STREAM_STATS:
      return {
        ...state,
        streamStatistics: action.statistics.map((stats) => ({
          ...stats,
          timestamp: Date.now()
        }))
      };
    case UPDATE_LATENCY:
      return {
        ...state,
        lag: parseFloat(action.latency).toFixed(2) || 0
      };
    default:
      return {...state};
  }
};

// SELECTORS
const isVisible = (state) => {
  return state.statistics.visible;
};

const getLag = (state) => {
  return state.statistics.lag;
};

const getNetworkState = (state) => {
  switch (state.statistics.networkState) {
    case 0:
      return 'Empty';
    case 1:
      return 'Idle';
    case 2:
      return 'Loading';
    case 3:
      return 'No source';
    default:
      return 'Unknown';
  }
};

const getStreamStatistics = (state) => {
  return state.statistics.streamStatistics;
};

const getHeight = (state) => {
  return state.statistics.height;
};

const getWidth = (state) => {
  return state.statistics.width;
};

export default statistics;
export {
  initialState,
  isVisible,
  getLag,
  getNetworkState,
  getStreamStatistics,
  getHeight,
  getWidth
};